export const KachColors = {
  green: '#60D89C',
  red: '#CE7676',
  blue: '#3182CE',
}
